import styles from "./Dots.module.scss";

function BouncingDotsLoader({ ballColors }: { ballColors: string[] }) {
  return (
    <div className={styles.Container}>
      {ballColors.map((color, ballNumber) => {
        return (
          <div
            key={color}
            className={styles.ball}
            style={{
              backgroundColor: color,
              animationDelay: `${ballNumber * 0.2}s`,
            }}
          />
        );
      })}
    </div>
  );
}

export default BouncingDotsLoader;
